(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      const list = details.closest('[data-accordion-list]');
      if (!list) return;

      list.querySelectorAll('details').forEach((item) => {
        if (item !== details) item.open = false;
      });
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-facets-auto-submit]');
    if (!select) return;
    const form = select.closest('form');
    if (form) form.submit();
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-facets-toggle]');
    if (!toggle) return;

    const form = toggle.closest('[data-facets]');
    const panel = form && form.querySelector('[data-facets-panel]');
    if (!panel) return;

    const willOpen = panel.hidden;
    panel.hidden = !willOpen;
    toggle.setAttribute('aria-expanded', String(willOpen));
  });

  // A filter panel with active selections should start open, so a customer
  // arriving on a filtered URL can see what's already applied rather than
  // having to discover it behind a collapsed control.
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-facets]').forEach((form) => {
      const panel = form.querySelector('[data-facets-panel]');
      const toggle = form.querySelector('[data-facets-toggle]');
      if (!panel || !toggle) return;

      const hasActive = panel.querySelector('.facets__checkbox:checked');
      if (hasActive) {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["policy-header"] && !Shopify.designMode) return;
  try {
    class PolicyNavInjector extends HTMLElement {
    connectedCallback() {
      const title = document.querySelector('.shopify-policy__title');
      const nav = this.querySelector('.policy-nav');
      if (!title || !title.parentNode || !nav) return;
      title.insertAdjacentElement('afterend', nav);
      this.remove();
    }
  }

  if (!customElements.get('policy-nav-injector')) {
    customElements.define('policy-nav-injector', PolicyNavInjector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-assets"] && !Shopify.designMode) return;
  try {
    class QuickAddButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.button');
      this.label = this.querySelector('.button__label');
      this._defaultText = this.label ? this.label.textContent : '';

      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      clearTimeout(this._resetTimer);
    }

    async _onClick(event) {
      if (!this.button || this.button.disabled) return;

      // snippets/card.liquid wraps the whole card (image, title, and this
      // button) in one <a> when a url is passed, so a click here would
      // otherwise both fire this AJAX add *and* navigate away via the
      // outer link — never letting the caller see "added" or stay in
      // place (the cart drawer's recommendation cards need exactly that).
      event.preventDefault();
      event.stopPropagation();

      const variantId = this.dataset.variantId;
      const url = this.dataset.cartAddUrl;
      if (!variantId || !url) return;

      clearTimeout(this._resetTimer);
      this.button.disabled = true;
      if (this.label) this.label.textContent = this.dataset.addingText;

      let failed = false;
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });

        if (!response.ok) throw new Error('Add to cart failed');

        if (this.label) this.label.textContent = this.dataset.addedText;
        this.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { variantId } }));
      } catch (error) {
        failed = true;
        if (this.label) this.label.textContent = this.dataset.errorText;
      } finally {
        // An error stays on screen longer than a success — a shopper needs
        // time to notice something went wrong, but "Added" only has to
        // confirm what the cart drawer is already showing them.
        this._resetTimer = setTimeout(() => {
          this.button.disabled = false;
          if (this.label) this.label.textContent = this._defaultText;
        }, failed ? 4000 : 1600);
      }
    }
  }

  if (!customElements.get('quick-add-button')) {
    customElements.define('quick-add-button', QuickAddButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.target = document.getElementById(this.dataset.watch);
      this.footer = document.querySelector('footer');
      if (!this.target || !('IntersectionObserver' in window)) return;

      this._targetVisible = true;
      this._footerVisible = false;
      this._update = this._update.bind(this);

      this._targetObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this._targetVisible = entry.isIntersecting || entry.boundingClientRect.top > 0;
        this._update();
      }, { threshold: 0 });
      this._targetObserver.observe(this.target);

      if (this.footer) {
        this._footerObserver = new IntersectionObserver((entries) => {
          this._footerVisible = entries[0].isIntersecting;
          this._update();
        }, { threshold: 0 });
        this._footerObserver.observe(this.footer);
      }
    }

    disconnectedCallback() {
      if (this._targetObserver) this._targetObserver.disconnect();
      if (this._footerObserver) this._footerObserver.disconnect();
    }

    _update() {
      this.classList.toggle('is-visible', !this._targetVisible && !this._footerVisible);
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-dialogs"] && !Shopify.designMode) return;
  try {
    class ThemeDialog extends HTMLElement {
    static openStack = [];
    static lockedScrollY = 0;

    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.dialog.dataset.themeDialogBound) return;
      this.dialog.dataset.themeDialogBound = 'true';

      this._closing = false;
      this._onDocumentClick = this._onDocumentClick.bind(this);
      this._onDialogClick = this._onDialogClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onCancel = this._onCancel.bind(this);

      this.dialog.addEventListener('cancel', this._onCancel);
      this.dialog.addEventListener('click', this._onDialogClick);

      this.querySelectorAll('[data-dialog-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      document.addEventListener('click', this._onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('keydown', this._onKeydown);

      const wasOpen = ThemeDialog.openStack.includes(this);
      ThemeDialog.openStack = ThemeDialog.openStack.filter((instance) => instance !== this);
      if (wasOpen && ThemeDialog.openStack.length === 0) this._releaseScrollLock();
    }

    _onDocumentClick(event) {
      const trigger = event.target.closest(`[data-dialog-open="${this.id}"]`);
      if (trigger) {
        event.preventDefault();
        this.open(trigger);
      }
    }

    _onDialogClick(event) {
      if (event.target === this.dialog && this.dataset.dismissible !== 'false') {
        this.close();
      }
    }

    _onCancel(event) {
      event.preventDefault();
      this.close();
    }

    _onKeydown(event) {
      if (event.key === 'Tab') this._trapFocus(event);
    }

    open(trigger) {
      if (!this.dialog || this.dialog.open) return;

      this._returnFocus = trigger || document.activeElement;

      if (ThemeDialog.openStack.length === 0) this._applyScrollLock();
      ThemeDialog.openStack.push(this);

      this.dialog.showModal();
      this.setAttribute('open', '');
      document.addEventListener('keydown', this._onKeydown);

      requestAnimationFrame(() => this.dialog.classList.add('is-open'));

      const initialFocus = this.querySelector('[autofocus]') || this.dialog;
      initialFocus.focus();

      this.dispatchEvent(new CustomEvent('theme:dialog:open', { bubbles: true }));
    }

    close() {
      if (!this.dialog || !this.dialog.open || this._closing) return;
      this._closing = true;

      const finish = () => {
        if (!this._closing) return;
        this._closing = false;

        this.dialog.close();
        this.removeAttribute('open');
        document.removeEventListener('keydown', this._onKeydown);

        ThemeDialog.openStack = ThemeDialog.openStack.filter((instance) => instance !== this);
        if (ThemeDialog.openStack.length === 0) this._releaseScrollLock();

        if (this._returnFocus && document.contains(this._returnFocus)) {
          this._returnFocus.focus();
        }

        this.dispatchEvent(new CustomEvent('theme:dialog:close', { bubbles: true }));
      };

      this.dialog.classList.remove('is-open');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }

      this.dialog.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 400);
    }

    _trapFocus(event) {
      const focusable = this.dialog.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    _applyScrollLock() {
      ThemeDialog.lockedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${ThemeDialog.lockedScrollY}px`;
      document.body.style.width = '100%';
    }

    _releaseScrollLock() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, ThemeDialog.lockedScrollY);
    }
  }

  class ThemeModal extends ThemeDialog {}
  class ThemeDrawer extends ThemeDialog {}

  if (!customElements.get('theme-modal')) customElements.define('theme-modal', ThemeModal);
  if (!customElements.get('theme-drawer')) customElements.define('theme-drawer', ThemeDrawer);
  } catch(e) { console.error(e); }
})();

})();
